import { render, staticRenderFns } from "./logPage.vue?vue&type=template&id=5d533dc9&scoped=true&"
import script from "./logPage.vue?vue&type=script&lang=js&"
export * from "./logPage.vue?vue&type=script&lang=js&"
import style0 from "./logPage.vue?vue&type=style&index=0&id=5d533dc9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d533dc9",
  null
  
)

export default component.exports